// Small Northeast states that can't hold an inline label — rendered instead as
// a stacked column of labeled "callout" boxes to the right of the map, colored
// to match the state's fill (and clickable, which also fixes the impossible-to-
// click-tiny-state problem). Order is roughly north → south.
export const CALLOUT_STATES = [
  "US-VT", "US-NH", "US-MA", "US-RI", "US-CT", "US-NJ", "US-DE", "US-MD", "US-DC",
];

// Callout column layout, in viewBox units (the viewBox is 0 0 960 600).
// Sits in the empty Atlantic space to the right of Maine. Tune here if needed.
export const CALLOUT = {
  x: 894,
  width: 58,
  top: 70,
  height: 24,
  gap: 4,
};

// Optional manual label-position overrides (viewBox coords) if polylabel ever
// needs a nudge for a specific state. Empty by default.
export const LABEL_OVERRIDES = {
  // "US-XX": [x, y],
};
